import { Modal } from '@base-app';
import { useAddCampaign } from './hooks/useAddCampaign';
import { Sizes } from '@/common/types';
import { useTranslation } from 'react-i18next';
import { STUDY_INSIGHTS_TRANSLATION } from '@/modules/study-insights/constants';
import { AddCampaignFormStringValues } from '../AddCampaignForm/AddCampaignForm.types';
import { AddCampaignForm } from '../AddCampaignForm';

interface AddCampaignModalProps {
  show: boolean;
  onClose: () => void;
  onCreateCampaign: (values: AddCampaignFormStringValues | undefined) => void;
  onErrorCreateCampaign?: (error: any) => void;
  modalTitle: string;
}

export const AddCampaignModal = ({
  show,
  onClose,
  onCreateCampaign,
  onErrorCreateCampaign,
  modalTitle,
}: AddCampaignModalProps): JSX.Element => {
  const { t } = useTranslation(STUDY_INSIGHTS_TRANSLATION);
  const {
    variables: campaignValues,
    isLoading: isCampaignLoading,
    mutateAsync: addCampaign,
  } = useAddCampaign({
    onSuccess: () => onCreateCampaign(campaignValues),
    onError: onErrorCreateCampaign,
  });

  const handleOnSubmit = async (values: AddCampaignFormStringValues): Promise<void> => {
    const validDistributionValues = values.volumeDistribution?.map((distribution) => ({
      numberOfEnrollees: distribution.numberOfEnrollees,
      distributionDate: distribution.distributionDate ?? '',
    }));

    const payload: Omit<AddCampaignFormStringValues, 'campaignID'> = {
      // At this point all validations should take place and no
      // empty values should exists on mandatory values
      campaignName: values.campaignName ?? '',
      campaignSource: values.campaignSource ?? '',
      campaignMedium: values.campaignMedium ?? '',
      campaignUrl: undefined,
      launchDate: values.launchDate ?? '',
      endDate: values.endDate ? values.endDate : undefined,
      campaignTerm: values.campaignTerm,
      campaignContent: values.campaignContent,
      volumeDistribution: validDistributionValues,
    };
    await addCampaign(payload);
  };

  return (
    <Modal show={show} title={modalTitle} onClose={onClose} size={Sizes.XXXX_LARGE}>
      <AddCampaignForm t={t} onCancel={onClose} onSubmit={handleOnSubmit} isLoading={isCampaignLoading} />
    </Modal>
  );
};
